import React, { useState, useEffect } from 'react'
import { Grid } from '@material-ui/core'
import MaterialTable from 'material-table'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import NumberFormat from 'react-number-format'
import { getTechnicalAssistanceApplicant } from '../../../../../../services/AsistenciaTecnica/get'

export const Table13 = (props) => {
  const {
    IdBeneficiaryType,
    IdTechnicalAssistanceAnswer,
    RequestedAmount,
    NumberOfApplicants,
  } = props

  const [data, setData] = useState([])

  const getTechnicalAssistanceApplicantList = async () => {
    try {
      const response = await getTechnicalAssistanceApplicant(
        IdTechnicalAssistanceAnswer,
      )
      if (response.Success) {
        setData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      IdTechnicalAssistanceAnswer !== '' &&
      IdTechnicalAssistanceAnswer !== null
    )
      getTechnicalAssistanceApplicantList()
  }, [
    IdBeneficiaryType,
    IdTechnicalAssistanceAnswer,
    RequestedAmount,
    NumberOfApplicants,
  ])

  const columns = [
    {
      title: 'Identificador MIPYME',
      field: 'MiPymeIdentifier',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'never',
    },
    {
      title: 'Nombre MIPYME',
      field: 'MiPymeName',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      align: 'center',
    },
    {
      title: 'Código proyecto',
      field: 'ProjectCode',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      align: 'center',
    },
    {
      title: 'Nombre proyecto',
      field: 'ProjectName',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      align: 'center',
    },
    {
      title: 'Monto asistencia técnica',
      field: 'RequestedAmount',
      sorting: false,
      filtering: false,
      align: 'right',
      render: (expense) => (
        <NumberFormat
          value={expense.RequestedAmount}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
  ]

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={data}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{
              Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
              Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            }}
          />
        </Grid>
      </Grid>
    </>
  )
}
